type CarouselProgressStepChangedPayload = {
	interactionIdentifier: 'carouselProgressIndicator';
	direction: 'next' | 'previous';
	fromStep: number;
	toStep: number;
};

export const fireCarouselProgressStepChanged = ({
	index,
	selectedIndex,
	onStepChanged,
}: {
	index: number;
	selectedIndex: number;
	onStepChanged: (payload: CarouselProgressStepChangedPayload) => unknown;
}): void => {
	if (index === selectedIndex) {
		return;
	}

	void onStepChanged({
		interactionIdentifier: 'carouselProgressIndicator',
		direction: index > selectedIndex ? 'next' : 'previous',
		fromStep: selectedIndex,
		toStep: index,
	});
};
